<template>
  <div class="layout">
    <div class="head_bg"
         id="head">
      <div class="container_row ">
        <div class="row top_tip">
          <div v-if="!IsShowPlatformImg">
            <div class="left-top">
              <font style="color:white; font-size: 24px;padding-left:50px;font-family: 微软雅黑">{{(type=='0'||type=='2')?'停车云平台管理系统封闭式场库':type=='1'?'城市智慧停车管理平台':'停车云平台管理系统封闭式场库'}}</font>
            </div>
          </div>
          <div v-if="IsShowPlatformImg">
            <div class="left-top">
              <font style="color:white; font-size: 24px;padding-left:20px;font-family: 微软雅黑">{{(type=='0'||type=='2')?'停车云平台管理系统封闭式场库':type=='1'?'城市智慧停车管理平台':'停车云平台管理系统封闭式场库'}}</font>
            <div v-if="true" class="left-top" style="padding-top:1px"><img src="../../assets/images/PlatformImg.png" style="width:180px;height:58px"/></div>
            </div>
          </div>
          <div class="right-top">
            <div class="pull-right">
              <a href='#'
                 @click="onLoginOut"
                 class="inactive">
                <img src="../../assets/images/logout.png"
                     class="login_out" />
                <font class="logout-font">退出系统</font>
              </a>
            </div>
            <div class="pull-right user-info"
                 @click="showEditPwd"
                 style="cursor: pointer">
              <font class="edit-pwd-font">修改密码</font>
            </div>
            <div class="pull-right date"><span>{{curDateStr}}</span></div>
            <div class="pull-right user-info"><span>{{userId}}:{{fUsrName}}[{{groupName}}]</span></div>
            <!-- <div class="pull-right"
                 v-if="menuList.indexOf(221010)>-1"><a target="_blank"
                 :href="auth_url"
                 class="auth-font">智慧物联网</a></div> -->
            <div class="pull-right etcErrorData"
                 @click="transferect" v-if="isShowEtcError"><span style="color:#24c5e7">ETC异常清算报表</span><span v-if="etcError" style="color:red">({{etcErrorCount}})</span></div>
            <div class="pull-right svrkanban"
                 @click="transfersvr"
                 v-if="(type=='0'||type=='2')&&(svrPanelUrl||'').length>0&&(fUserNoTemp==svrPanelUsrNo)"><span style="color:#24c5e7">服务器监测看板</span></div>
            <div class="pull-right kanban"
                 @click="transfer"
                 v-if="menuList.indexOf(230010)>-1&&(type=='0'||type=='2')&&(panelUrl||'').length>0"><span style="color:#24c5e7">看板</span></div>
            <div class="pull-right"><span style="color:red">{{custDateTimeStr}}</span></div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="修改密码"
               :visible.sync="dialogVisible"
               v-dialogDrag
               top="7vh"
               left="0vh"
               width="30%">
      <edit-pwd :form="form"
                @editpwdcallback="editpwdcallback"
                ref="child"></edit-pwd>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import EditPwd from '../../components/editPwd'
import * as api from '@/api/user'
export default {
  name: 'top',
  components: { EditPwd },
  data () {
    return {
      IsShowPlatformImg: false,
      auth_url: '',
      curDateStr: '',
      panelUrl: '',
      svrPanelUrl: '',
      svrPanelUsrNo: '',
      timer: '',
      eTCErrorTimer: '',
      userId: '',
      groupName: '',
      fUsrName: '',
      form: {
        fUsrID: '',
        fUsrNo: '',
        fUsrPwdOld: '',
        fUsrPwd: '',
        checkPass: '',
        fUsrName: ''
      },
      dialogVisible: false,
      isShowEtcError: false,
      etcError: false,
      etcErrorCount: ''
    }
  },
  props: {
    type: { type: String, required: true },
    menuList: { type: Array, required: true },
    custDateTimeStr: { type: String, required: true }
  },
  created () {
    this.panelUrl = localStorage.getItem('panelUrl')
    this.svrPanelUrl = localStorage.getItem('svrPanelUrl')
    this.fUserNoTemp = localStorage.getItem('fUserNo')
    this.svrPanelUsrNo = localStorage.getItem('svrPanelUsrNo')
    this.getTimer()
    if (this.fUserNoTemp === this.svrPanelUsrNo) {
      this.getETCErrorTimer()
    }
    var fIsDefaultPwd = localStorage.getItem('fIsDefaultPwd')
    if (fIsDefaultPwd === 'true') {
      this.$confirm('当前密码为默认密码，建议修改登录密码, 是否继续?', '安全提醒', {
        confirmButtonText: '去修改',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      }).then(() => {
        this.showEditPwd()
      }).catch(() => {
        localStorage.removeItem('fIsDefaultPwd')
      })
    }
    api.initConfig().then(res => {
      let { data } = res
      if (data.IsOk) {
        this.IsShowPlatformImg = data.Data.isShowPlatformImg
      }
    })
  },
  mounted () {
    this.timer = setInterval(this.getTimer, 1000)
    this.fUserNoTemp = localStorage.getItem('fUserNo')
    this.svrPanelUsrNo = localStorage.getItem('svrPanelUsrNo')
    if (this.fUserNoTemp === this.svrPanelUsrNo) {
      this.eTCErrorTimer = setInterval(this.getETCErrorTimer, 3600 * 1000)
    }
    this.userId = localStorage.getItem('fUserNo')
    this.groupName = localStorage.getItem('fGroupName')
    this.fUsrName = localStorage.getItem('fUsrName')
    this.getCurrentUser().then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            Object.assign(this.form, data.Data)
            this.form.fUsrPwd = ''
          }
        }
      }
    })
  },
  beforeDestroy () {
    clearInterval(this.timer)
    if (this.fUserNoTemp === this.svrPanelUsrNo) {
      clearInterval(this.eTCErrorTimer)
    }
  },
  methods: {
    ...mapActions([
      'logOut', 'getCurrentUser'
    ]),
    showEditPwd () {
      this.form.fUsrPwd = ''
      this.form.fUsrPwdOld = ''
      this.form.checkPass = ''
      if (typeof (this.$refs.child) !== 'undefined') {
        this.$refs.child.clearForm()
      }
      this.dialogVisible = true
    },
    editpwdcallback () {
      this.dialogVisible = false
    },
    dataFormat (time) {
      return `${time.getFullYear()}-${time.getMonth() + 1 >= 10 ? (time.getMonth() + 1) : '0' + (time.getMonth() + 1)}-${time.getDate() >= 10 ? time.getDate() : '0' + time.getDate()}
                     ${time.getHours() >= 10 ? time.getHours() : '0' + time.getHours()} : ${time.getMinutes() >= 10 ? time.getMinutes() : '0' + time.getMinutes()} : ${time.getSeconds() >= 10 ? time.getSeconds() : '0' + time.getSeconds()}`
    },
    getTimer () {
      this.curDateStr = this.dataFormat(new Date())
    },
    getETCErrorTimer () {
      if (this.fUserNoTemp === this.svrPanelUsrNo) {
        api.getEtcErrorCount().then(res => {
          let { data } = res
          if (data.IsOk) {
            if (data.Data > 0) {
              this.isShowEtcError = true
              this.etcError = true
              this.etcErrorCount = data.Data
            } else {
              this.isShowEtcError = true
              this.etcError = false
            }
          }
        })
      }
    },
    transfer () {
      var rember = localStorage.getItem('rember')
      var fUsrID = localStorage.getItem('fUsrID')
      var fUserNo = localStorage.getItem('fUserNo')
      // var panelUrl = localStorage.getItem('panelUrl')
      window.open(this.panelUrl + '?fUsrID=' + fUsrID + '&fUsrNo=' + fUserNo + '&rember=' + rember, '_blank')
    },
    transfersvr () {
      var rember = localStorage.getItem('rember')
      var fUsrID = localStorage.getItem('fUsrID')
      var fUserNo = localStorage.getItem('fUserNo')
      // var svrPanelUrl = localStorage.getItem('svrPanelUrl')
      window.open(this.svrPanelUrl + '?fUsrID=' + fUsrID + '&fUsrNo=' + fUserNo + '&rember=' + rember, '_blank')
    },
    transferect () {
      window.open(window.location.origin + '/#/ETCErrorPayDataList', '_blank')
    },
    onLoginOut () {
      this.logOut().then(res => {
        // this.$router.push('/login')
        window.location.href = window.location.origin + '/#/login'
      })
    }
  }
}
</script>

<style>
.layout .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
.layout .el-dialog__title {
  color: white;
}
.layout .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
</style>

<style scoped>
.auth-font {
  color: #67c23a;
}
.edit-pwd-font {
  color: #e6a23c;
}
.logout-font {
  color: #f56c6c;
}
.row.top_tip {
  font-size: 13.5px;
}
a,
a:hover {
  text-decoration: none;
}
.head_bg {
  width: 100%;
  height: 60px;
  /*background: #334877;*/
  background: black;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  font-family: 微软雅黑;
}
.inactive {
  text-align: center;
  display: block;
  color: white;
}

.container_row {
  margin: 0px !important;
  padding: 0px !important;
  line-height: 60px;
  width: 100%;
  overflow: hidden;
}

.container_row .pull-right span {
  color: white;
}
.kanban {
  cursor: pointer;
}
.svrkanban {
  cursor: pointer;
}
.etcErrorData {
  cursor: pointer;
}
.container_row .left-top {
  float: left;
}

.container_row .right-top {
  float: right;
}

.container_row .pull-right {
  float: right;
  margin-right: 20px;
}

.container_row .loginout img {
  width: 40px;
  height: 40px;
}

.container_row .login_out {
  width: 12px;
  height: 12px;
  vertical-align: middle;
  margin-right: 3px;
  margin-top: -2px;
}
</style>



// WEBPACK FOOTER //
// src/view/home/top.vue